import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  tilesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    marginBottom: '82px',
  },
  section: {
    backgroundColor: whiteColor,
  },
}));
